// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1rNWV","inner":"Footer_inner__2e8Kd","nextIcon":"Footer_nextIcon__4wlrV","innerLeft":"Footer_innerLeft__1fwhO"};